/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetFireStoreTimestamp,
    PickupTimeWindowResponse,
    SetPickupTimeWindowRequest,
} from '../models';

export interface CommonsApiControllerSetPickupTimeWindowRequest {
    setPickupTimeWindowRequest: SetPickupTimeWindowRequest;
}

/**
 * 
 */
export class CommonsApi extends runtime.BaseAPI {

    /**
     * Public API
     */
    async commonsApiControllerGetPickupTimeWindowRaw(): Promise<runtime.ApiResponse<PickupTimeWindowResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/commons/pickup-time-window`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async commonsApiControllerGetPickupTimeWindow(): Promise<PickupTimeWindowResponse> {
        const response = await this.commonsApiControllerGetPickupTimeWindowRaw();
        return await response.value();
    }

    /**
     * Public API
     */
    async commonsApiControllerGetServerTimestampRaw(): Promise<runtime.ApiResponse<GetFireStoreTimestamp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/commons/server-timestamp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async commonsApiControllerGetServerTimestamp(): Promise<GetFireStoreTimestamp> {
        const response = await this.commonsApiControllerGetServerTimestampRaw();
        return await response.value();
    }

    /**
     */
    async commonsApiControllerRecordAccessSourceRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/access-sources`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async commonsApiControllerRecordAccessSource(): Promise<void> {
        await this.commonsApiControllerRecordAccessSourceRaw();
    }

    /**
     */
    async commonsApiControllerSetPickupTimeWindowRaw(requestParameters: CommonsApiControllerSetPickupTimeWindowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.setPickupTimeWindowRequest === null || requestParameters.setPickupTimeWindowRequest === undefined) {
            throw new runtime.RequiredError('setPickupTimeWindowRequest','Required parameter requestParameters.setPickupTimeWindowRequest was null or undefined when calling commonsApiControllerSetPickupTimeWindow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/commons/pickup-time-window`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setPickupTimeWindowRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async commonsApiControllerSetPickupTimeWindow(requestParameters: CommonsApiControllerSetPickupTimeWindowRequest): Promise<void> {
        await this.commonsApiControllerSetPickupTimeWindowRaw(requestParameters);
    }

}
